module.exports = __webpack_public_path__ + "static/media/wizualizacja-63.22fec51a.png";